import { render, staticRenderFns } from "./TheFooterNavHorizontal.vue?vue&type=template&id=42ab56f8"
import script from "./TheFooterNavHorizontal.vue?vue&type=script&lang=js"
export * from "./TheFooterNavHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports